var React = require('react');

function LineRightMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m240 0v48.375l-240-0.625v40.742","stroke":"#dae0e5","strokeWidth":"2","fill":"none"}));
}

LineRightMobile.defaultProps = {"height":"85","width":"240","viewBox":"0 0 242 85"};

module.exports = LineRightMobile;

LineRightMobile.default = LineRightMobile;
